app.factory('mainModel', ['$rootScope', 'baseModel',
    function($rootScope, baseModel) {
        function MainModel() {

            var self = this;

            this.applicationItems = [];
            this.menuItems = [];
            this.sideBarItems = [];
            this.breadcrumbItems = [];

            this.titleBar = {};

            this.slidePanelState = {
                collapsed: false
            };

            this.setApplicationItems = function(items) {
                self.applicationItems = items;
            };

            this.setMenuItems = function(items) {
                self.menuItems = items;
            };

            this.setSideBarItems = function(items) {
                this.sideBarItems = items;
            };

            this.setTitleBar = function(titleBarTitle, titleBarIconClass, titleBarSubtitle) {
                self.titleBar = {
                    title: titleBarTitle,
                    icon: titleBarIconClass,
                    subtitle: titleBarSubtitle
                };
            };

            this.selectMenuItemWithState = function(state) {
                this.deselectMenuItems();

                var menuItemToSelect = _.find(self.menuItems, { state: state });

                if (menuItemToSelect) {
                    menuItemToSelect.selected = true;
                }
            };

            this.deselectMenuItems = function() {
                _.each(self.menuItems, function(menuItem) {
                    menuItem.selected = false;
                });
            };

            this.selectSideBarItemWithState = function(state, childState) {
                this.deselectSideBarItems();

                var sideBarItemToSelect = _.find(self.sideBarItems, { state: state });

                if (sideBarItemToSelect) {
                    sideBarItemToSelect.selected = true;

                    if (childState) {
                        var childSideBarItemToSelect = _.find(sideBarItemToSelect.children, { state: childState });
                        if (childSideBarItemToSelect) {
                            childSideBarItemToSelect.selected = true;
                        }
                    }
                }
            };

            this.deselectSideBarItems = function() {
                _.each(self.sideBarItems, function(sideBarItem) {
                    sideBarItem.selected = false;

                    _.each(sideBarItem.children, function(childSideBarItem) {
                        childSideBarItem.selected = false;
                    });
                });
            };

            this.setBreadcrumbItems = function(items) {
                self.breadcrumbItems = items;
            };

        }

        return new MainModel();
    }
]);
